<template>
  <div
    style="
      display: flex;
      width: 100%;
      align-items: center;
      align-content: center;
    "
    id="lv_Air_Quality"
    class="centerHeader"
  >
    <div
      style="display: flex; width: calc(100% / 2)"
      class="al-center"
      v-for="i in labeltext2"
      :key="i"
    >
      <div
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <vs-icon
          size="25px"
          class="mr-2"
          :color="i.color"
          icon="fiber_manual_record"
        ></vs-icon>
        <div>
          <a class="text_size" style="font-weight: 800">{{ i.text }}</a
          ><br /><a style="font-weight: 600" class="thFontthai text_size">{{
            i.th
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      labeltext2: [
        {
          text: "Under standard",
          th: "ค่าอยู่ในเกณฑ์มาตรฐาน",
          color: "#00D257",
        },
        { text: "Over standard", th: "ค่าเกินเกณฑ์มาตรฐาน", color: "#FF3235" },
      ],
      // labeltext2: [
      //   { text: "Excellent", th: "ดีมาก", color: "#3BCCFF" },
      //   { text: "Good", th: "ดี", color: "#00D257" },
      //   { text: "Moderate", th: "ปานกลาง", color: "#FFDF2F" },
      //   { text: "Unhealthy", th: "เริ่มมีผลต่อสุขภาพ", color: "#F6942B" },
      //   { text: "Very Unhealthy", th: "มีผลต่อสุขภาพ", color: "#FF3235" },
      // ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "./../aqi.scss";
.centerHeader {
  text-align: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  padding: 10px;
  height: 100%;
}
</style>
